import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Menu, Drawer } from 'antd';
import ChildMenu from './ChildMenu';
import {
	TeamOutlined,
	DesktopOutlined,
	BulbOutlined,
	LineChartOutlined 
} from '@ant-design/icons';
import './help.css';


class ParentMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			childrenDrawer : false,
			childMenu : ''
		}
	}

  componentDidMount() {
		
	}

	componentDidUpdate(prevProps) {
		
  }

	handleClick = e => {
	
		if(e.key !== ""){
			this.setState({childrenDrawer : true,childMenu : e.key})
		}
		
	};
	showChildrenDrawer = () => {
		this.setState({childrenDrawer : true});
	  };
	onChildrenDrawerClose = () => {
		this.setState({childrenDrawer : false});
	  };
	render() {
		const {  userTheme} = this.props;
		const { SubMenu } = Menu;
			return (
				<div className='parentMenu'>
					
					<ul className={userTheme === 'dark'? 'navHolderA' :'navHolder'}>
						{
							<Menu
								onClick={this.handleClick}
								defaultOpenKeys={['1', '2','4']}
								mode="inline"
								theme= {userTheme}
								className= {userTheme === 'dark'? 'navHolderA' :'navHolder'}
								//onTitleClick={this.handleClick} 
								>
								<SubMenu key="1" icon={<BulbOutlined />} title="Getting Started" >
									<Menu.Item key="Getting Started">Getting Started</Menu.Item>
									<Menu.Item key="Craffview Overview">Craffview Overview</Menu.Item>
									<Menu.Item key="Users" >Users</Menu.Item>
									<Menu.Item key="Workspaces" disabled={true}>Workspaces</Menu.Item>
									<Menu.Item key="Integration" >Integration</Menu.Item>
									<Menu.Item key="SDK Overview" disabled={true}>SDK Overview</Menu.Item>
								</SubMenu>
								<SubMenu key="2" icon={<TeamOutlined />} title="Administrative" >
									<Menu.Item key="Logging into Craffview" >Logging into Craffview</Menu.Item>
									<Menu.Item key="Managing Account" >Managing Account</Menu.Item>
									<Menu.Item key="Setting" >Setting</Menu.Item>
								</SubMenu>
								<SubMenu key="3" icon={<DesktopOutlined />} title="Managing the ads" disabled={true}>
									
									
								</SubMenu>
								<SubMenu key="4" icon={<LineChartOutlined />} title="Data & Analytics" disabled={true}>
									<Menu.Item key="Export Data" disabled={true}>Export Data</Menu.Item>
								</SubMenu>
							</Menu>
						}
					</ul>
						
					
						<Drawer
					title={"Help - " + this.state.childMenu}
					width={400}
					closable={false}
					onClose={this.onChildrenDrawerClose}
					open={this.state.childrenDrawer}
					>
					<ChildMenu menu ={this.state.childMenu}/>
					</Drawer>
				</div>
			);
	}

}
//<span className="logout"><a onClick={() => this.onLogout()}><LogoutOutlined style={{ marginRight: '10px' }} />Logout</a></span>

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParentMenu));
